<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">View Domains</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="24">
          <a-col :span="8">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search" @input="onSearch"></a-input>
            </div>
          </a-col>
          <a-col :span="8">
            <div class="full-w a-select-group" :class="{ active: !!filterParams.status }">
              <a-button size="large">
                <a-icon type="filter"></a-icon>
              </a-button>
              <a-select v-model="filterParams.status" :size="'large'" placeholder="Status" @change="onChangeStatus">
                <template v-for="status in statusList">
                  <a-select-option :key="status.value" :value="status.value">
                    {{ status.value }}
                  </a-select-option>
                </template>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :pagination="pagin"
            :columns="DomainListColumn"
            :dataSource="filterData"
            :tableSize="tableSize"
            >
            <template slot="domain" slot-scope="{ record }">
              <a-tooltip :title="record.domain" placement="topLeft">
                <router-link :to="'/domain/' + record.domain_id + '/webpages'">
                  {{ record.domain }}
                </router-link>
              </a-tooltip>
            </template>
            <template slot="status" slot-scope="{ record }">
                <a-tag
                  :color="'#236B8E'">
                  {{ record.status }}
                </a-tag>
              <!-- <template v-for="statusItem in statusList">
                <a-tag
                  :key="statusItem.value"
                  :color="statusItem.color">
                  {{ record.status }}
                </a-tag>
              </template> -->
            </template>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item>
                    <router-link :to="'/domain/' + record.domain_id + '/webpages'">
                      <img class="mr-2" src="@assets/icon/report.svg" />
                      List of URLs
                    </router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link :to="'/domain/' + record.domain_id + '/crawl-result-management'">
                      <img class="mr-2" src="@assets/icon/report.svg" />
                      Crawl Results
                    </router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link :to="'/domain/' + record.domain_id + '/ignored-webpages'">
                      <img class="mr-2" src="@assets/icon/report.svg" />
                      List of Ignored URLs
                    </router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click.prevent="confirmDeleteRecord(record)"><img class="mr-2" src="@assets/icon/delete.svg" /> Delete</div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
    <a-modal
      v-model="isShowPopupConfirmDeleteDomain"
      style="top: 20px;"
      width="80vw"
      class="rebaseline-modal"
      title="Delete Domain"
      cancelText="Cancel"
      okText="Delete"
      :cancelButtonProps="{ style: { float: 'right' } }"
      :okButtonProps="{ style: { marginRight: '8px' } }"
      :afterClose="afterCloseReBaselineModal"
      :closable="true"
      :maskClosable="true"
      @ok="submitDeleteDomain"
      :confirm-loading="isProcessingOkConfirmDeleteDomain"
    >
      <div>
        <p>
          The following webpages will also be deleted:
        </p>
        <div v-if="isLoadingPopupConfirmDeleteDomain" class="d-flex justify-content-center align-items-center pt-35-px">
          <Spinner />
        </div>
        <div v-if="!isLoadingPopupConfirmDeleteDomain">
          <PaginationTable
            :columns="DeleteDomainColumn"
            :dataSource="urlsToDelete"
            >
            <template slot="webpageUrl" slot-scope="{ record }">
              <a class="url" :href="record.url" target="_blank" rel="noopener noreferrer">{{ record.url }}</a>
            </template>
            <template slot="healthStatus" slot-scope="{ record }">
              <a-tag :color="STATUS_COLOR[record.health_status]">
                {{ record.health_status }}
              </a-tag>
            </template>
            <template slot="monitorType" slot-scope="{ record }">
              <p class="mb-0">{{ record.monitoring_type | lowercase | capitalize }}</p>
            </template>
          </PaginationTable>
        </div>
        <p class="mb-0 mt-3">
          Are you sure you want to delete?
          <br/>
          All URLs pertaining to this domain will be deleted.
        </p>
      </div>
      <!-- <div v-if="isSuccessMultipleBaseline">
        <div class="success-rebaseline-container">
          <div>
            <a-icon type="check-circle" theme="filled" class="check-success" />
          </div>
          <div class="ml-3">
            <p class="mb-1 notice-text">{{ multipleReBaselineData.length }} webpages has been queued for rebaseline.</p>
            <p class="mb-1 notice-text">
              This may take a few minutes to a few hours depending on the number of pages.
            </p>
            <p class="mb-1 notice-text">
              You may check the status of this batch job
              <span>
                <router-link class="nav-link-detail" :to="{ path: '/batch-jobs/detail/RB' + batchIdsuccessMultipleBaseResponse }">
                  ID
                  {{ 'RB' + batchIdsuccessMultipleBaseResponse }} at this link.
                </router-link>
              </span>
            </p>
            <p class="mb-0 notice-text">An email will be sent to {{ currentUserName }} when the job is finished.</p>
          </div>
        </div>
      </div> -->
    </a-modal>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { DomainListColumn } from '../columnsTable/DomainListColumn';
  import { DeleteDomainColumn } from '../columnsTable/DeleteDomainColumn';
  import DomainService from '../services/Domain.service';
  import { STATUS_COLOR } from '@constants/statusColor';

  const statusList = [
    {
      value: 'OK',
      color: '#008000',
    },
    {
      value: 'WARNING',
      color: '#ffa500',
    },
    {
      value: 'CRITICAL',
      color: '#ff0000',
    },
    {
      value: 'Continuous Monitoring',
      color: '#236B8E',
    },
  ];

  export default {
    name: 'DomainList',
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize) {
        pageSize = 5;
      }

      return {
        DomainListColumn,
        statusList,
        DeleteDomainColumn,
        domainsData: [],
        filterData: [],
        filterParams: {
          search: '',
          status: '',
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0,
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: '',
        },
        subscribedDomainWebpagesById: [],
        isShowPopupConfirmDeleteDomain: false,
        isLoadingPopupConfirmDeleteDomain: false,
        isProcessingOkConfirmDeleteDomain: false,
        urlsToDelete: [],
        domainToDelete: -1,
        STATUS_COLOR: STATUS_COLOR,
      };
    },
    mounted() {
      this.fetchList();
    },
    beforeDestroy() {},
    methods: {
      onSearch: debounce(function (event) {
        const searchTerm = (event.target.value && String(event.target.value).trim().toLowerCase()) || '';
        this.filterParams.search = searchTerm.trim();
        this.filter();
      }, 800),
      onChangeStatus(value) {
        this.filterParams.status = value;
        this.filter();
      },
      filter() {
        let filterResult = [];
        const { search, status } = this.filterParams;
        filterResult = search ? this.domainsData.filter((item) => (item.url_name || '').toString().toLowerCase().includes(search)) : this.domainsData;
        this.filterData = filterResult;
        this.pagin.total = filterResult.length;
      },
      async fetchList() {
        try {
          const [
            responseData,
            listOfDomain
          ] = await Promise.all([
            DomainService.fetchResourcesActive(),
            DomainService.fetchListOfDomainSubscribed()
          ]);

          // domain_name
          this.domainsData = (responseData || []).map((item) => ({
            id: item.id,
            domain: item.domain_name,
            domain_id: item.domain.id,
            status: item.status,
            committedPollingInterval: `Every ${item.polling_interval} mins`,
            variablePollingInterval: `${item.variable_rate} URLs every ${item.polling_interval} minutes`,
            committedURLs: item.committedURLs,
            variableURLs: item.variableURLs,
            healthStatusOk: '...',
            healthStatusWarning: '...',
            healthStatusCritical: '...',
            healthStatusContinuousMonitoring: '...',
            monitoringTypeCommitted: '...',
            monitoringTypeVariable: '...'
          }));
          this.filter();

          // fetch the extra domain stats
          (responseData || []).map(async (item) => {
            let domainId = item.domain.id;
            let domain = item.domain_name;
            let domainStats = await DomainService.fetchDomainStatisticsById(domainId);
            console.log(domainStats);

            let matchedDomain = this.domainsData.find((item) => item.domain === domain);
            matchedDomain.healthStatusOk = domainStats.health_status['OK'] ? domainStats.health_status['OK'] : 0;
            matchedDomain.healthStatusWarning = domainStats.health_status['WARNING'] ? domainStats.health_status['WARNING'] : 0;
            matchedDomain.healthStatusCritical = domainStats.health_status['CRITICAL'] ? domainStats.health_status['CRITICAL'] : 0;
            matchedDomain.healthStatusContinuousMonitoring = domainStats.health_status['Continuous Monitoring'] ? domainStats.health_status['Continuous Monitoring'] : 0;
            matchedDomain.monitoringTypeCommitted = domainStats.monitoring_type['Committed'];
            matchedDomain.monitoringTypeVariable = domainStats.monitoring_type['Variable'];
          });
        } catch (error) {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
        this.fetchList();
      },
      elSizeChange(size) {
        this.tableSize = size;
      },
      async confirmDeleteRecord(record) {
        this.urlsToDelete = [];
        this.isLoadingPopupConfirmDeleteDomain = true;
        this.isShowPopupConfirmDeleteDomain = true;
        const fetchUrls = await DomainService.fetchSubscribedDomainWebpagesById(record.domain_id);
        this.urlsToDelete = fetchUrls;
        this.isLoadingPopupConfirmDeleteDomain = false;
        this.domainToDelete = record.domain_id;
      },
      async submitDeleteDomain() {
        this.isProcessingOkConfirmDeleteDomain = true;
        try {
          let domain = await DomainService.deleteDomain(this.domainToDelete);
          this.$showSuccessMessage(`Domain ${domain.name} deleted`);
        } catch {
          this.$showErrorMessage('HTTP error received from web server!');
        } finally {
          this.domainToDelete = -1;
          await this.fetchList();
          this.isProcessingOkConfirmDeleteDomain = false;
          this.isShowPopupConfirmDeleteDomain = false;
        }
      },
      afterCloseReBaselineModal() {
        this.subscribedDomainWebpagesById.length = 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
    white-space: nowrap;
  }
  .nav-link-detail {
    width: 100%;
    &:hover {
      text-decoration: underline;
    }
  }
  .nav-link-detail {
    display: inline-block;
  }
  .custom-suffix {
    font-size: 20px;
    color: #20a4b8;
  }
  .webpab-ext-link {
    color: inherit;
    display: block;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:hover {
      color: #20a4b8;
      text-decoration: underline;
    }
  }
</style>
